/* Copyright (c) Trimble Inc. All rights reserved. */

import { useEffect } from "react";
import { ProductListViewModel } from "./ProductList.viewer";
import { AsyncActionState, useAsyncAction } from "legacy-components/form/action/AsyncAction";
import {  from, of } from "rxjs";
import { Product } from "./ProductStackview";
import { Controller } from "modus/utilities/ViewController";
import { IProduct } from "pages/home/consumer/service/ProductService";
import { AxiosResponse } from "axios";
import { ConsumerProductService } from "pages/home/consumer/service/ConsumerProductService";
import { useSelector } from "react-redux";

/**
 * @name useTeamListController
 * @description controller to handle TeamList component functionalities and serves model for ApplicationViewer
 * @type Controller
 * @input TeamListControllerProps
 * @output TeamListViewModel
 */
export const useProductListController:Controller<{},ProductListViewModel> = () => {
    const identityEnvironment = useSelector((state: any) => state?.common?.identityEnvironment);
    const [response, {subscribe}] = useAsyncAction(() => ConsumerProductService.getProductList(identityEnvironment));
    // Input details
    useEffect(() => {
        if(!subscribe || !identityEnvironment) {
            return
        }

        subscribe();
    }, [subscribe, identityEnvironment]);

    return {
        asyncResponse : response as AsyncActionState<AxiosResponse<IProduct[]> | null>
        ,
    };
};
